import BaseJoi from 'joi';
import extension from 'joi-date-extensions';
import { YEARS_SICK } from '../LegalParameters/Constants';

const Joi = BaseJoi.extend(extension);

export default Joi.object({
	pay: Joi.number()
		.precision(0)
		.positive()
		.error(() => ({
			message: 'Hrubá měsíční mzda musí být kladné číslo.',
		})),
	pay_hour: Joi.number()
		.precision(2)
		.positive()
		.error(() => ({
			message: 'Průměrný hodinový výdělek musí být kladné číslo.',
		})),
	hours: Joi.number()
		.precision(0)
		.min(0)
		.max(14 * 24)
		.error(errors => {
			if (errors[0].type === 'number.max') {
				return {
					message: 'Počet hodin pracovní neschopnosti nesmí být větší než 14*24 hodin.',
				};
			}

			return {
				message: 'Počet hodin pracovní neschopnosti v prvních 14 dnech musí být kladné číslo.',
			};
		}),
	days: Joi.number()
		.precision(0)
		.min(0)
		.error(() => ({
			message: 'Celkový počet dní pracovní neschopnosti musí být kladné číslo.',
		})),
	year: Joi.valid(YEARS_SICK),
});
